export const LIMITE_MENSAGEM_CHAT = 2000;

export const EMOJIS_CHAT = [
  "😀",
  "😁",
  "😂",
  "😊",
  "😍",
  "🤩",
  "😉",
  "😎",
  "🤔",
  "😅",
  "😢",
  "😭",
  "😡",
  "👍",
  "👎",
  "👏",
  "🙏",
  "👌",
  "💪",
  "❤️",
  "🧡",
  "✅",
  "❌",
  "🎉",
];

export function inserirEmoji(texto, emoji, limite = LIMITE_MENSAGEM_CHAT) {
  const atual = texto || "";
  const simbolo = emoji || "";
  if (!simbolo || atual.length + simbolo.length > limite) {
    return atual;
  }
  return atual + simbolo;
}
